import { createFileRoute } from '@tanstack/react-router'
import { AssetAssessment } from 'pages/assetAssessment/AssetAssessment'
import { SEARCH_PARAM_UNIT_ID } from 'routes/(common_search_params)/-searchParams'
import { SEARCH_PARAM_SITE_ID } from 'routes/(global_search_params)/-searchParams'
import { z } from 'zod'

const assetAssessmentSearchParams = z.object({
  [SEARCH_PARAM_SITE_ID]: z.string(),
  [SEARCH_PARAM_UNIT_ID]: z.string().optional(),
})

export const Route = createFileRoute('/asset-assessment/')({
  component: RouteComponent,
  validateSearch: assetAssessmentSearchParams,
  staticData: {
    title: 'Asset Assessment',
  },
})

function RouteComponent() {
  const { siteId, unitId } = Route.useSearch()

  return <AssetAssessment siteId={siteId} unitId={unitId} />
}
